module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-17.6abaa50a.mp3";